import "./App.css";
import { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "./theme";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Register } from "./pages/Register";
import { Login } from "./pages/Login";
import CssBaseline from "@mui/material/CssBaseline";
import { NextUIProvider } from "@nextui-org/react";
import { I18nProvider } from "react-aria";

import { getAuth, onAuthStateChanged } from "firebase/auth";
import { ConfirmarAta } from "./pages/EditarMidia/ConfirmarAta";
import { SplashScreen } from "./components/splash-screen";
import { Dashboard } from "./pages/Dashboard";
import { Vinculos } from "./pages/Vinculos";
import { Entidades } from "./pages/Entidades";
import { Paltas } from "./pages/Paltas";
import { CadastroEntidades } from "./pages/CadastroEntidades";
import { EntidadesInfo } from "./pages/EntidadesInfo";
import { UnidadesGestorasCadastro } from "./pages/CadastroUnidadesGestoras";
import { CadastroSessoes } from "./pages/CadastroOrgaos";
import { Sessoes } from "./pages/Sessoes";
import { ForgotPassword } from "./pages/ForgotPassword";
import { SessoesPlenarioInfo } from "./pages/SessoesPlenarioInfo";
import { Sessao } from "./pages/Sessao";
import { EditarSessao } from "./pages/EditarSessao";
import Legilasturas from "./pages/Legislatura";
import { LegilasturasCadastro } from "./pages/LegilasturasCadastro";
import { ExcluirConta } from "./pages/ExcluirConta";
import { CadastroGrandeExpediente } from "./pages/CadastroGrandeExpediente";
import { PerfilParlamentar } from "./pages/PerfilParlamentar";
import { EditarPauta } from "./pages/EditarPauta";
import { ResumoSessao } from "./pages/ResumoSessao";
import { EditarMidia } from "./pages/EditarMidia";
import { NewsModal } from "./components/NewsModal";
import { useNewsModal } from "./hooks/useNewsModal";

export default function App() {
  const theme = createTheme({
    colorPreset: "blue",
    contrast: "normal",
    direction: "ltr",
    paletteMode: "vertical",
    responsiveFontSizes: true,
  });

  const [UserSession, setUserSession] = useState<boolean>(true);
  const [showSlashScreen, setShowSlashScreen] = useState<boolean>(true);
  const { showModal, handleCloseModal } = useNewsModal();

  useEffect(() => {
    const auth = getAuth();

    onAuthStateChanged(auth, (user) => {
      if (user) {
        setShowSlashScreen(false);
        setUserSession(true);
      } else {
        setShowSlashScreen(false);
        setUserSession(false);
      }
    });
  }, []);

  return (
    <BrowserRouter>
      <NextUIProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />

          {showSlashScreen ? (
            <SplashScreen />
          ) : UserSession ? (
            <Routes>
              <Route path="/" element={<Dashboard />}>
                <Route index element={<Entidades />} />
                <Route
                  path="/parlamentar/:id"
                  element={<PerfilParlamentar />}
                />
                <Route
                  path="/parlamentares/cadastro"
                  element={<CadastroEntidades />}
                />
                <Route path="/pautas" element={<Paltas />} />
                <Route
                  path="/pautas/cadastro"
                  element={<UnidadesGestorasCadastro />}
                />
                <Route path="/pauta/:id/edit" element={<EditarPauta />} />
                <Route path="/sessoes" element={<Sessoes />} />
                <Route path="/sessoes/cadastro" element={<CadastroSessoes />} />
                <Route path="/sessoes/:id/vis" element={<EntidadesInfo />} />
                <Route path="/sessoes/:id/edit" element={<EditarSessao />} />
                <Route
                  path="/plenario-digital/sessoes"
                  element={<Vinculos />}
                />
                <Route
                  path="/plenario-digital/sessoes/:id/edit"
                  element={<SessoesPlenarioInfo />}
                />
                <Route path="/sessoes/:id/resumo" element={<ResumoSessao />} />
                <Route
                  path="/sessoes/:id/resumo/midia"
                  element={<EditarMidia />}
                />
                <Route
                  path="/sessoes/:id/resumo/midia/confirmar-ata"
                  element={<ConfirmarAta />}
                />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
              <Route path="/sessao/tela/1/:id" element={<Sessao />} />
            </Routes>
          ) : (
            <Routes>
              <Route index path="/cadastro" element={<Register />} />
              <Route index path="/login" element={<Login />} />
              <Route index path="/send-email" element={<ForgotPassword />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          )}

          {/* Modal de Novidades */}
          <NewsModal
            open={showModal && UserSession}
            onClose={handleCloseModal}
          />
        </ThemeProvider>
      </NextUIProvider>
    </BrowserRouter>
  );
}
